module.exports = __webpack_public_path__ + "img/banner.3f9439b.png";